import { ContactMailSharp } from '@material-ui/icons';
import React, { memo } from 'react';
import {useState} from 'react';
import { Handle } from 'react-flow-renderer';
import DesignCard from './DesignCard';

// import mouse from '../img/mouse.png';
import './dnd.css';
import MouseIcon from '@material-ui/icons/MouseTwoTone';

export default memo(({ data }) => {

  const designerIconStyle = {
    backgroundImage:'linear-gradient(to bottom, grey, royalblue)', color:'white', borderRadius:'20px',  marginLeft:'20px'
}

const renderIcon = (selected) =>{
  if (selected == true)
  {
    return (
    // <img draggable={false} draggable={false} src={mouse} width='50' height='50'></img>
    <MouseIcon fontSize='large' style={designerIconStyle} draggable={false} />


    // <img draggable={false} style={{border: '4px solid lightblue' }} draggable={false} src={mouse} width='50' height='50'></img>
    )
  }

  return (
  // <img draggable={false} src={mouse} width='50' height='50'></img>
  <MouseIcon fontSize='large' style={designerIconStyle} draggable={false}/>

  )


}
// const toBinString = (bytes) =>
//   bytes.reduce((str, byte) => str + byte.toString(2).padStart(8, '0'), '');

  const renderImage = () => {
    
    console.log("Rendering click image from cloud")

    // const view = new Uint8Array(data.clickImage);

    // const buffer = Buffer.from(data.clickImage);
    // const base64String = buffer.toString();

    // var source = "data:image/png;base64,"  + base64String;

    return(
      <img className='clickimage'  src={data.clickImageData}></img>  
    )    


  }

    const [img, setImg] = useState(null);
    // const url = "data:image/png;base64,"  + img 

    return (
    <div >
      <Handle
        type="target"
        position="top"
        style={{ background: '#555' }}
        onConnect={(params) => console.log('handle onConnect', params)}
      />
      {renderImage()}      
      <div className="row" >
        {renderIcon(data.selected)}
        <h4 style={{color: 'black', textAlign:'left'}}>{data.label}  </h4>
      </div>

      <Handle
        type="source"
        position="bottom"
        id="b2"
        style={{ bottom: -5, top: 'auto', background: '#555' }}
      />
    </div>
  );

});